// extracted by mini-css-extract-plugin
module.exports = {"appear":"review-animation_appear__2M_Wj","appearActive":"review-animation_appearActive__3Xi91"};